import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: "root",
})
export class ApiService {
    constructor(private readonly http: HttpClient) { }

    public isLinkifyWorking(urlLinkifyTest: string): Observable<boolean> {
        return this.http.get<{ code: string, message: string }>(urlLinkifyTest, { observe: 'response' }).pipe(
            map(response => response.status === 200)
        );
    }
}
